import { schema } from 'normalizr';

export const inviteSchema = new schema.Entity('invite');
